export const contentTableConfig = {
  title: '公众号相关',
  propList: [
    {prop: 'type', label: '类型', minWidth: '40', slotName: 'type'},
    {prop: 'certifiedStatus', label: '认证状态', minWidth: '40', slotName: 'certifiedStatus'},
    {prop: 'certifiedEnterprise', label: '认证企业', minWidth: '50'},
    {prop: 'thirdParty', label: '所属第三方', minWidth: '50'},
    {prop: 'expireTime', label: '到期时间', minWidth: '60', sortable: true},
    {prop: 'name', label: '名称', minWidth: '60'},
    {prop: 'liveTeacher', label: '直播老师', minWidth: '50'},
    {prop: 'oaAccount', label: '账号', minWidth: '60'},
    {prop: 'manager', label: '管理员', minWidth: '50'},
    {prop: 'remark', label: '备注', minWidth: '60'},
    {
      label: '操作',
      minWidth: '60',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
